import { createUseStyles } from 'react-jss'

import config from 'styles/config'
import { textSize, titleFont } from '@portal/kit/pkg/styles'

const instructionStyles = createUseStyles(theme => ({
  instructionsTitle: {
    ...titleFont(),
    ...textSize(16, 19),
    marginBottom: 8,
  },
  instructions: {
    listStyleType: 'decimal',
    marginBottom: 16,

    '& li': {
      listStyleType: 'decimal',
      marginLeft: 26,
      marginBottom: 8,
      ...textSize(14, 19),
    }
  },
  [config.mediaQueries.tabletPortrait]: {
    instructionsTitle: {
      marginBottom: 16,
    },
  }
}))

export default instructionStyles
